export default "__VITE_ASSET__c8453d40__"